import React, { useCallback, useEffect } from 'react';
import { Loading } from 'tdesign-react';
import { useSearchParams } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  fetchClusterDetailByName,
  resetClusterDetail,
  fetchAllClusterEnvs,
  toggleHistoryOpen,
} from '@/slices/clusterSlice';
import { getChartsData } from '@/services/clusterService';
import {
  fetchAllDeployEnvs,
  fetchAllPulsarVersions,
  fetchClusterUsage,
  fetchAllBKVersions,
  fetchAllDeployVersions,
  fetchAllZKVersions,
} from '@/slices/dictSlice';
import BoardPanel from '@/components/Cluster/BoardPanel';
import HistoryPanel from '@/components/Cluster/HistoryPanel';
import BasicInfo from './BasicInfo';
import Summary from './Summary';

function Dashboard({
  detailLoading,
  fetchClusterDetailByName,
  fetchAllDeployEnvs,
  fetchAllClusterEnvs,
  fetchAllPulsarVersions,
  fetchClusterUsage,
  fetchAllBKVersions,
  fetchAllDeployVersions,
  fetchAllZKVersions,
  resetClusterDetail,
  historyOpen,
  toggleHistoryOpen,
}) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');
  const showLoading = !clusterName || detailLoading;

  const doLoad = useCallback(() => {
    if (clusterName) {
      fetchClusterDetailByName(clusterName);
      fetchAllDeployEnvs();
      fetchAllClusterEnvs();
      fetchAllBKVersions();
      fetchClusterUsage();
      fetchAllZKVersions();
      fetchAllDeployVersions();
      fetchAllPulsarVersions();
    }
  }, [
    clusterName,
    fetchClusterDetailByName,
    fetchAllDeployEnvs,
    fetchAllClusterEnvs,
    fetchAllPulsarVersions,
    fetchClusterUsage,
    fetchAllBKVersions,
    fetchAllDeployVersions,
    fetchAllZKVersions,
  ]);

  useEffect(() => {
    doLoad();
    return () => {
      resetClusterDetail();
    };
  }, [doLoad, resetClusterDetail]);

  if (!clusterName) return null;

  return (
    <Loading loading={showLoading}>
      <Root $open={historyOpen}>
        <Left>
          <Summary />
        </Left>
        <Right>
          <BasicInfo doRefresh={doLoad} />
          <BoardPanel
            getChartsData={async (params) => await getChartsData({ clusterName, ...params })}
          />
        </Right>
      </Root>
      <HistoryPanel toggleHistoryOpen={toggleHistoryOpen} historyOpen={historyOpen} type='pulsar' />
    </Loading>
  );
}

export default connect(
  (state) => ({
    detailLoading: state.cluster.detailLoading,
    historyOpen: state.cluster.historyOpen,
  }),
  {
    fetchClusterDetailByName,
    fetchAllDeployEnvs,
    fetchAllClusterEnvs,
    fetchAllBKVersions,
    fetchClusterUsage,
    fetchAllZKVersions,
    fetchAllDeployVersions,
    fetchAllPulsarVersions,
    resetClusterDetail,
    toggleHistoryOpen,
  },
)(Dashboard);

const Root = styled.div`
  display: flex;
  padding-right: 10px;
  min-width: 1060px;
  transition: 0.4s margin cubic-bezier(0.645, 0.045, 0.355, 1);
  margin-right: ${(props) => (props.$open ? 248 : 40)}px;
`;

const Left = styled.div`
  width: 260px;
  margin-right: 16px;
  flex-shrink: 0;
`;

const Right = styled.div`
  flex: 1;
  margin-right: 3px;
`;
